import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'

import TabItem from './TabItem'

import useStyles from './styles'

const Tabs = ({ options, selectedValue, onSelectValue }) => {
  const classes = useStyles()

  const selectTabHandler = useCallback(
    value => {
      onSelectValue && onSelectValue(value)
    },
    [onSelectValue]
  )

  const filteredOptions = useMemo(
    () =>
      options.filter(item => {
        return item.value && item.label
      }),
    [options]
  )

  return (
    <div className={classes.tabsContainer}>
      {filteredOptions.map(item => (
        <TabItem
          key={item.value}
          tabItem={item}
          isActive={item.value === selectedValue}
          onClick={() => selectTabHandler(item.value)}
        />
      ))}
    </div>
  )
}

Tabs.propTypes = {
  options: PropTypes.array,
  selectedValue: PropTypes.string,
  onSelectValue: PropTypes.func
}

export default Tabs
